import { cn } from './chunk-FFX3LZW7.js';
import { Loader2 } from 'lucide-react';
import { jsxs, jsx } from 'react/jsx-runtime';

var SIZES = {
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-8 w-8"
};
function Spinner({ size = "md", className, label = "Loading" }) {
  return /* @__PURE__ */ jsxs("span", { role: "status", "aria-live": "polite", className: "inline-flex items-center", children: [
    /* @__PURE__ */ jsx(Loader2, { className: cn("animate-spin text-muted-foreground", SIZES[size], className) }),
    /* @__PURE__ */ jsx("span", { className: "sr-only", children: label })
  ] });
}

export { Spinner };
//# sourceMappingURL=chunk-T2TNXQRV.js.map
//# sourceMappingURL=chunk-T2TNXQRV.js.map